export default __webpack_public_path__ + "static/media/mexico.701f6fde.jpg";